export default {
    'Mega Menu': 'Mega-Menü',
    Search: 'Suche',
    Menu: 'Speisekarte',
    Dashboard: 'Instrumententafel',
    Calendar: 'Kalender',
    Chat: 'Plaudern',
    Ecommerce: 'E-Commerce',
    Products: 'Produkte',
    'Product Detail': 'Produktdetail',
    Orders: 'Aufträge',
    Customers: 'Kunden',
    Cart: 'Wagen',
    Checkout: 'Auschecken',
    Shops: 'Geschäfte',
    'Add Product': 'Produkt hinzufügen',
    Email: 'Email',
    Inbox: 'Posteingang',
    'Read Email': 'E-Mail lesen',
    'Kanban Board': 'Kanban Board',
    Layouts: 'Layouts',
    Horizontal: 'Horizontal',
    'Dark Sidebar': 'Dunkle Seitenleiste',
    'Default Sidebar': 'Standard-Seitenleiste',
    'Compact Sidebar': 'Kompakte Seitenleiste',
    'Icon Sidebar': 'Symbol Seitenleiste',
    'Boxed Layout': 'Boxed Layout',
    'Fluid Layout': 'Flüssigkeitsanordnung',
    Preloader: 'Preloader',
    'Without Preloader': 'Ohne Preloader',
    Pages: 'Seiten',
    Authentication: 'Authentifizierung',
    Login: 'Anmeldung',
    Register: 'Registrieren',
    'Recover Password': 'Passwort wiederherstellen',
    'Lock Screen': 'Bildschirm sperren',
    Utility: 'Nützlichkeit',
    'Starter Page': 'Starter-Seite',
    Maintenance: 'Instandhaltung',
    'Coming Soon': 'Demnächst',
    Timeline: 'Zeitleiste',
    FAQs: 'FAQs',
    Pricing: 'Preisgestaltung',
    'Error 404': 'Fehler 404',
    'Error 500': 'Fehler 500',
    Components: 'Komponenten',
    'UI Elements': 'UI-Elemente',
    Alerts: 'Warnungen',
    Buttons: 'Tasten',
    Cards: 'Karten',
    Carousel: 'Karussell',
    Dropdowns: 'Dropdowns',
    Grid: 'Gitter',
    Images: 'Bilder',
    Lightbox: 'Leuchtkasten',
    Modals: 'Modale',
    'Range Slider': 'Range Slider',
    'Round Slider': 'Runder Schieberegler',
    'Session Timeout': 'Session-Timeout',
    'Progress Bars': 'Fortschrittsbalken',
    'Sweet-Alert': 'Sweet-Alert',
    'Tabs & Accordions': 'Tabs & Akkordeons',
    Typography: 'Typografie',
    Video: 'Video',
    General: 'Allgemeines',
    Rating: 'Bewertung',
    Notifications: 'Benachrichtigungen',
    Forms: 'Formen',
    Elements: 'Elemente',
    Validation: 'Validierung',
    'Advanced Plugins': 'Erweiterte Plugins',
    Editors: 'Redakteure',
    'File Upload': 'Datei-Upload',
    'X-editable': 'X-editierbar',
    Wizard: 'Magier',
    Mask: 'Maske',
    Tables: 'Tabellen',
    'Basic Tables': 'Grundtabellen',
    'Data Tables': 'Datentabellen',
    'Responsive Table': 'Antworttabelle',
    'Editable Table': 'Bearbeitbare Tabelle',
    Charts: 'Diagramme',
    Apexcharts: 'Apexcharts',
    Chartist: 'Chartist',
    Chartj: 'Chartj',
    'Jquery Knob': 'Jquery Knob',
    Sparkline: 'Sparkline',
    Icons: 'Symbole',
    'Remix Icons': 'Remix-Symbole',
    'Material Design': 'Material Design',
    Dripicons: 'Dripicons',
    'Font awesome 5': 'Font awesome 5',
    Maps: 'Karten',
    'Google Maps': 'Google Maps',
    'Vector Maps': 'Vektorkarten',
    'Multi Level': 'Multi Level',
    'Level 1.1': 'Stufe 1.1',
    'Level 1.2': 'Stufe 1.2',
    'Level 2.1': 'Stufe 2.1',
    'Level 2.2': 'Stufe 2.2',
    Profile: 'Profil',
    'My Wallet': 'Mein Geldbeutel',
    Settings: 'die Einstellungen',
    'View more': 'Mehr sehen',
    'View all': 'Alle ansehen',
    Logout: 'Ausloggen',
    'Your order is placed': 'Ihre Bestellung wird aufgegeben',
    'If several languages coalesce the grammar': 'Wenn mehrere Sprachen die Grammatik verschmelzen',
    'Your item is shipped': 'Ihr Artikel wird versendet',
    '3 min ago': 'Vor 3 min',
    'James Lemire': 'James Lemire',
    'It will seem like simplified English.': 'Es wird wie vereinfachtes Englisch erscheinen.',
    '1 hours ago': 'Vor 1 Stunde',
    'Salena Layfield': 'Salena Layfield',
    'As a skeptical Cambridge friend of mine occidental.': 'Als skeptischer Cambridge-Freund von mir Occidental.',
    'View More..': 'Mehr sehen..',
    'UI Components': 'UI-Komponenten',
    Applications: 'Anwendungen',
    'Extra Pages': 'Zusätzliche Seiten',
    Github: 'Github',
    Bitbucket: 'Bit Bucket',
    Dribble: 'Dribbeln',
    Dropbox: 'Dropbox',
    'Mail Chimp': 'Mail Schimpanse',
    Slack: 'Locker'
};
